import { apiSortOptions } from "./sort";
import { PLAN_MARKET_FILTER_OPTIONS } from "./planMarkets";
import { programClassifications } from "@tailormed/common-client/constant/assistanceProgram";
import { INTERNAL_PROGRAM } from "./assistanceProgram";
import { APPLICATION_FORM_SIGNATURE_STATUS_FILTER_OPTIONS } from "./applicationFormSignatureEnrollment";

export const ALL = "all";

export const POTENTIAL_SAVINGS_FILTER_TYPES = {
  FOUNDATION_COPAY: "foundation_copay",
  FOUNDATION_PREMIUM: "foundation_premium",
  MANUFACTURER_COPAY: "manufacturer_copay",
  MANUFACTURER_PAP: "manufacturer_pap",
  MANUFACTURER_OTHER: "manufacturer_other",
  ANCILLARY_LIVING: "ancillary_living",
  SUPPORT_ADHERENCE: "support_adherence",
  GOVERNMENT_PLANS: "government_plans",
  DISCOUNT: "discount",
  INTERNAL: INTERNAL_PROGRAM
};
export const ALL_TIMES = "all_times";
export const DATE_RANGE = "date_range";
export const UNASSIGNED = "unassigned";
export const NO_CHANGE = "no_change";
// Insurance Change Types
export const ALL_CHANGES = "all_changes";
export const BECAME_INSURED = "became_insured";
export const BECAME_UNINSURED = "became_uninsured";
export const PLAN_MARKET_CHANGE = "plan_market";
export const OTHER_INSURANCE_CHANGE = "other";

// Consent Status Types (MVP-28674) - Aligned with backend ConsentEventTypes
export const ConsentStatusTypes = Object.freeze({
  NO_RECORD: "no_record",
  LINK_EXPIRED: "link_expired",
  LINK_SENT: "link_sent", // Backend: ConsentEventTypes.LINK_SENT
  CONSENT_ACCEPTED: "consent_accepted", // Backend: ConsentEventTypes.CONSENT_ACCEPTED
  CONSENT_REVOKED: "consent_revoked", // Backend: ConsentEventTypes.CONSENT_REVOKED
  CONSENT_EXPIRED: "consent_expired" // Backend: ConsentEventTypes.CONSENT_EXPIRED
});
// PAST
export const LAST_3_DAYS = "last_3_days";
export const LAST_WEEK = "last_week";
export const LAST_MONTH = "last_month";
export const LAST_YEAR = "last_year";
export const LAST_2_MONTHS = "last_2_months";
export const LAST_3_MONTHS = "last_3_months";
export const PAST_12_MONTHS = "past_12_months";
// Relative date filters (from current date, not calendar months)
export const PAST_1_MONTH = "past_1_month";
export const PAST_3_MONTHS = "past_3_months";
// FUTURE
export const TODAY = "today";
export const NEXT_2_DAYS = "next_2_days";
export const NEXT_3_DAYS = "next_3_days";
export const NEXT_7_DAYS = "next_7_days";
export const NEXT_30_DAYS = "next_30_days";
export const LAST_90_DAYS = "last_90_days";
export const THIS_WEEK = "this_week";
export const THIS_MONTH = "this_month";
export const FOLLOWING_WEEK = "following_week";
export const WITHIN_A_WEEK = "weekly";
export const WITHIN_A_MONTH = "monthly";
export const NEXT_MONTH = "next_month";

// Time Since Last Activity filter options
export const MORE_THAN_7_DAYS = "more_than_7_days";
export const MORE_THAN_14_DAYS = "more_than_14_days";
export const MORE_THAN_30_DAYS = "more_than_30_days";
export const MORE_THAN_60_DAYS = "more_than_60_days";

export const CREATED_AT_ASCEND = "createdAt:ASC";
export const CREATED_AT_DESCEND = "createdAt:DESC";
export const ORIGINAL_FILENAME_ASCEND = "originalFilename:ASC";
export const ORIGINAL_FILENAME_DESCEND = "originalFilename:DESC";

export const FN = "fn";
export const PHARMACY = "pharmacy";

export const FREE_DRUGS = "free-drugs";
export const COPAYS = "copays";
export const LIVING_EXPENSES = "living-expenses";
export const GOVERNMENT_PLANS = "government-plans";
export const OTHER = "other";
export const INDEFINITELY = "indefinitely";

export const maxStartSearchCharactersLength = 3;

export const dateFilterTypes = {
  pastFilters: [
    { title: "Last 3 Days", value: LAST_3_DAYS },
    { title: "Last Week", value: LAST_WEEK },
    { title: "Last Month", value: LAST_MONTH }
  ],
  followUpFilters: [
    { title: "Today", value: TODAY },
    { title: "This Week", value: THIS_WEEK },
    { title: "Following Week", value: FOLLOWING_WEEK }
  ],
  claimDateFilters: [
    { title: "Last Week", value: LAST_WEEK },
    { title: "Last Month", value: LAST_MONTH },
    { title: "Next 7 Days", value: NEXT_7_DAYS },
    { title: "Next 30 Days", value: NEXT_30_DAYS }
  ],
  claimFollowupDateFilters: [
    { title: "Today", value: TODAY, id: "claim_followup_date_today" },
    { title: "Last Week", value: LAST_WEEK, id: "claim_followup_date_last_week" },
    { title: "Last Month", value: LAST_MONTH, id: "claim_followup_date_last_month" },
    { title: "Next 7 Days", value: NEXT_7_DAYS, id: "claim_followup_date_next_7_days" },
    { title: "Next 30 Days", value: NEXT_30_DAYS, id: "claim_followup_date_next_30_days" }
  ],
  claimSubmittedDateFilters: [
    { title: "Last Week", value: LAST_WEEK },
    { title: "Last Month", value: LAST_MONTH },
    { title: "Last 90 Days", value: LAST_90_DAYS }
  ],
  dateOfServiceFilters: [
    { title: "Last Week", value: LAST_WEEK },
    { title: "Last Month", value: LAST_MONTH },
    { title: "Next 7 Days", value: NEXT_7_DAYS },
    { title: "Next 30 Days", value: NEXT_30_DAYS }
  ],
  claimReceivedDateFilters: [
    { title: "Last Week", value: LAST_WEEK },
    { title: "Last Month", value: LAST_MONTH },
    { title: "Last 90 Days", value: LAST_90_DAYS }
  ],
  claimTimeSinceLastActivityFilters: [
    { title: "More Than 7 Days", value: MORE_THAN_7_DAYS, id: "claim_time_since_last_activity_more_than_7_days" },
    { title: "More Than 14 Days", value: MORE_THAN_14_DAYS, id: "claim_time_since_last_activity_more_than_14_days" },
    { title: "More Than 30 Days", value: MORE_THAN_30_DAYS, id: "claim_time_since_last_activity_more_than_30_days" },
    { title: "More Than 60 Days", value: MORE_THAN_60_DAYS, id: "claim_time_since_last_activity_more_than_60_days" }
  ],
  visitScheduleDateRangeFilters: [
    { title: "Next 3 Days", value: NEXT_3_DAYS },
    { title: "Next 2 Days", value: NEXT_2_DAYS },
    { title: "Today", value: TODAY }
  ],
  validThroughDateRangeFilters: [
    { title: "Last Month", value: LAST_MONTH },
    { title: "Last Week", value: LAST_WEEK },
    { title: "Next Month", value: NEXT_MONTH }
  ],
  validThroughDateRangeAllApplicationFilters: [
    { title: "Last Month", value: LAST_MONTH },
    { title: "Last Week", value: LAST_WEEK },
    { title: "Next Month", value: NEXT_MONTH },
    { title: "Indefinitely", value: INDEFINITELY }
  ],
  medicationCreatedDateFilters: [
    { title: "Today", value: TODAY, id: TODAY },
    { title: "Last 3 Days", value: LAST_3_DAYS, id: LAST_3_DAYS },
    { title: "Last Week", value: LAST_WEEK, id: LAST_WEEK },
    { title: "Last Month", value: LAST_MONTH, id: LAST_MONTH },
    { title: "Last 3 Months", value: LAST_3_MONTHS, id: LAST_3_MONTHS }
  ],
  approvedDateFilters: [
    { title: "Last Week", value: LAST_WEEK },
    { title: "Last Month", value: LAST_MONTH },
    { title: "Last 2 Months", value: LAST_2_MONTHS }
  ],
  appliedDateFilters: [
    { title: "Last Week", value: LAST_WEEK, id: LAST_WEEK },
    { title: "Last Month", value: LAST_MONTH, id: LAST_MONTH },
    { title: "Last 2 Months", value: LAST_2_MONTHS, id: LAST_2_MONTHS }
  ],
  enrollmentCreationDateFilters: [
    { title: "Last Week", value: LAST_WEEK, id: "enrollment_created_date_last_week" },
    { title: "Last Month", value: PAST_1_MONTH, id: "enrollment_created_date_last_month" },
    { title: "Last 3 Months", value: PAST_3_MONTHS, id: "enrollment_created_date_last_3_months" },
    { title: "Last 12 Months", value: PAST_12_MONTHS, id: "enrollment_created_date_last_12_months" },
    { title: "Last Year", value: LAST_YEAR, id: "enrollment_created_date_last_year" }
  ],
  inviteSentDateFilters: [
    { title: "Last Week", value: LAST_WEEK, id: "invite_sent_date_last_week" },
    { title: "Last Month", value: LAST_MONTH, id: "invite_sent_date_last_month" },
    { title: "Last 3 Months", value: LAST_3_MONTHS, id: "invite_sent_date_last_3_months" }
  ],
  patientViewedDateFilters: [
    { title: "Last Week", value: LAST_WEEK, id: "patient_viewed_date_last_week" },
    { title: "Last Month", value: LAST_MONTH, id: "patient_viewed_date_last_month" },
    { title: "Last 3 Months", value: LAST_3_MONTHS, id: "patient_viewed_date_last_3_months" }
  ]
};

export const insuranceChangeTypeOptions = [
  { key: "1", value: NO_CHANGE, translationText: "no_change", id: "insurance_change_type_no_change" },
  { key: "2", value: ALL_CHANGES, translationText: "all_changes", id: "insurance_change_type_all_changes" },
  {
    key: "3",
    value: BECAME_INSURED,
    translationText: "became_insured",
    id: "insurance_change_type_became_insured"
  },
  {
    key: "4",
    value: BECAME_UNINSURED,
    translationText: "became_uninsured",
    id: "insurance_change_type_became_uninsured"
  },
  {
    key: "5",
    value: PLAN_MARKET_CHANGE,
    translationText: "plan_market_change",
    id: "insurance_change_type_plan_market"
  }
];

export const insuranceChangeTimeframeOptions = [
  { key: "1", value: LAST_WEEK, translationText: "last_week", id: "insurance_change_timeframe_last_week" },
  { key: "2", value: LAST_MONTH, translationText: "last_month", id: "insurance_change_timeframe_last_month" },
  {
    key: "3",
    value: LAST_3_MONTHS,
    translationText: "last_3_months",
    id: "insurance_change_timeframe_last_3_months"
  }
];

export const consentStatusOptions = [
  {
    key: "1",
    value: ConsentStatusTypes.NO_RECORD,
    translationText: "consent_status_no_record",
    id: "consent_status_no_record"
  },
  {
    key: "2",
    value: ConsentStatusTypes.LINK_EXPIRED,
    translationText: "consent_status_link_expired",
    id: "consent_status_link_expired"
  },
  {
    key: "3",
    value: ConsentStatusTypes.LINK_SENT,
    translationText: "consent_status_pending_signature",
    id: "consent_status_pending_signature"
  },
  {
    key: "4",
    value: ConsentStatusTypes.CONSENT_ACCEPTED,
    translationText: "consent_status_received",
    id: "consent_status_received"
  },
  {
    key: "5",
    value: ConsentStatusTypes.CONSENT_REVOKED,
    translationText: "consent_status_revoked",
    id: "consent_status_revoked"
  },
  {
    key: "6",
    value: ConsentStatusTypes.CONSENT_EXPIRED,
    translationText: "consent_status_expired",
    id: "consent_status_expired"
  }
];

export const defaultFilters = {
  starredPatients: false,
  inActiveTreatment: false,
  hideDeceasedPatients: false,
  enrollmentsCreatedByPatients: false,
  expressEnrollEligible: false,
  claimExists: null,
  groupPatientVisits: false,
  insuranceCombination: false,
  isUnassigned: false,
  internalProgram: false,
  isUnassignedEnrollment: false,
  isUnassignedClaim: false,
  hasInsuranceChanges: false,
  insuranceChangeType: NO_CHANGE,
  insuranceChangeTimeframe: LAST_WEEK,
  patientNeverViewed: false,
  dates: {
    patientCreationDateRange: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    enrollmentCreationDateRange: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    visitScheduleDateRange: {
      fromDate: null,
      toDate: null,
      value: NEXT_3_DAYS
    },
    followupDate: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    claimDate: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    claimFollowupDate: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    claimSubmittedDate: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    dateOfService: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    claimReceivedDate: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    claimTimeSinceLastActivity: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    coverageChangeDate: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    medicationCreatedDate: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    activeDate: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    validThroughDateRange: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    approvedDateRange: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    appliedDateRange: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    inviteSentDateRange: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    },
    patientViewedDateRange: {
      fromDate: null,
      toDate: null,
      value: ALL_TIMES
    }
  },
  multiples: {
    planMarketTypes: {},
    ageRanges: [],
    statuses: {},
    claimStatuses: {},
    assignees: {},
    facilities: {},
    claimFacilities: {},
    visitFacilities: {},
    doctors: {},
    payers: {},
    drugDoseFormCategories: {},
    diagnosisTypes: {},
    rxnormDrugs: [],
    claimRxnormDrugs: [],
    diagnosisNames: {},
    diagnosisCodeIDs: {},
    potentialSavingsTypes: {},
    potentialSavingsDrugDoseFormCategories: {},
    potentialSavingsAPSponsor: {},
    potentialSavingsAplicationStatuses: {},
    topOppAPStatuses: {},
    importedStatuses: [],
    applicationSignatureStatuses: [],
    enrollmentAssignee: {},
    claimAssignee: {},
    claimLastSavedBy: {},
    consentStatus: {}
  },
  numbers: {
    remainingOOP: 0,
    applicationFundBalance: 0
  }
};

export const defaultFiltersInputs = {
  ageRanges: [],
  statuses: [],
  claimStatuses: [],
  assignees: [],
  isUnassigned: false,
  isUnassignedEnrollment: false,
  isUnassignedClaim: false,
  claimExists: null,
  facilities: [],
  claimFacilities: [],
  visitFacilities: [],
  doctors: [],
  payers: [],
  planMarketTypes: [],
  rxnormDrugs: [],
  claimRxnormDrugs: [],
  drugDoseFormCategories: [],
  diagnosisTypes: [],
  importedStatuses: [],
  diagnosisNames: [],
  diagnosisCodeIDs: [],
  potentialSavingsTypes: [],
  potentialSavingsDrugDoseFormCategories: [],
  potentialSavingsRxnormDrugs: [],

  potentialSavingsAplicationStatuses: [],
  potentialSavingsAPSponsor: [],
  topOppAPStatuses: [],
  patientCreationDateRange: ALL_TIMES,
  enrollmentCreationDateRange: ALL_TIMES,
  visitScheduleDateRange: NEXT_3_DAYS,
  followupDate: ALL_TIMES,
  claimDate: ALL_TIMES,
  claimFollowupDate: ALL_TIMES,
  claimSubmittedDate: ALL_TIMES,
  claimReceivedDate: ALL_TIMES,
  claimTimeSinceLastActivity: ALL_TIMES,
  coverageChangeDate: ALL_TIMES,
  medicationCreatedDate: ALL_TIMES,
  activeDate: ALL_TIMES,
  validThroughDateRange: ALL_TIMES,
  approvedDateRange: ALL_TIMES,
  appliedDateRange: ALL_TIMES,
  applicationSignatureStatuses: [],
  enrollmentAssignee: [],
  claimAssignee: [],
  claimLastSavedBy: [],
  consentStatus: [],
  inviteSentDateRange: ALL_TIMES,
  patientViewedDateRange: ALL_TIMES,
  patientNeverViewed: false
};

export const NOT_DONE = null;
export const DONE = "checked";

export const defaultTaskFilters = {
  timeRange: { fromDate: ALL_TIMES, toDate: null },
  assigneesFilter: [],
  status: NOT_DONE
};

export const defaultSavedListFilters = Object.freeze({
  query: "",
  limit: 10,
  skip: 0,
  orderBy: "updatedAt",
  filterBy: "all",
  sortBy: "DESC"
});

export const defaultSavedListSorting = {
  all: { name: apiSortOptions.desc, updatedAt: apiSortOptions.desc, orderBy: defaultSavedListFilters.orderBy },
  private: { name: apiSortOptions.desc, updatedAt: apiSortOptions.desc, orderBy: defaultSavedListFilters.orderBy },
  starred: { name: apiSortOptions.desc, updatedAt: apiSortOptions.desc, orderBy: defaultSavedListFilters.orderBy },
  shared: { name: apiSortOptions.desc, updatedAt: apiSortOptions.desc, orderBy: defaultSavedListFilters.orderBy }
};

const POTENTIAL_SAVINGS_TYPES = [
  {
    key: programClassifications.MANUFACTURER_COPAY.value,
    value: programClassifications.MANUFACTURER_COPAY.value,
    translationText: "manufacturer_copay"
  },
  {
    key: programClassifications.MANUFACTURER_PAP.value,
    value: programClassifications.MANUFACTURER_PAP.value,
    translationText: "manufacturer_pap_and_replacement"
  },
  {
    key: programClassifications.MANUFACTURER_OTHER.value,
    value: programClassifications.MANUFACTURER_OTHER.value,
    translationText: "manufacturer_other"
  },
  {
    key: programClassifications.FOUNDATION_COPAY.value,
    value: programClassifications.FOUNDATION_COPAY.value,
    translationText: "foundation_copay"
  },
  {
    key: programClassifications.FOUNDATION_PREMIUM.value,
    value: programClassifications.FOUNDATION_PREMIUM.value,
    translationText: "foundation_premium"
  },
  {
    key: programClassifications.FOUNDATION_LIVING.value,
    value: programClassifications.FOUNDATION_LIVING.value,
    translationText: "ancillary_living_expenses"
  },
  {
    key: programClassifications.GOVERNMENT_ASSISTANCE.value,
    value: programClassifications.GOVERNMENT_ASSISTANCE.value,
    translationText: "government_plans"
  },
  {
    key: programClassifications.DISCOUNT_CARDS.value,
    value: programClassifications.DISCOUNT_CARDS.value,
    translationText: "discount"
  },
  {
    key: programClassifications.INTERNAL_PROGRAMS.value,
    value: programClassifications.INTERNAL_PROGRAMS.value,
    translationText: "internal"
  }
];

export const tableFilterValues = {
  drugDoseFormCategory: [
    { key: "1", value: "isInfusion", translationText: "infusion" },
    { key: "2", value: "isSubcutaneous", translationText: "subcutaneous" },
    { key: "3", value: "isOralOrOther", translationText: "oral_and_others" }
  ],
  pendingRenewalAPStatuses: [
    { value: "approved", translationText: "Approved", localSortKey: 4 },
    { value: "expired", translationText: "Expired", localSortKey: 5 },
    { value: "exhausted", translationText: "exhausted", localSortKey: 6 }
  ],
  claimExists: [
    { key: "1", value: true, translationText: "tableFilters.exists" },
    { key: "2", value: false, translationText: "tableFilters.doesnt_exists" }
  ],
  allApplicationsAPStatuses: [
    { translationText: "patientApplications.prepare", value: "prepare", localSortKey: 1 },
    { translationText: "patientApplications.applied", value: "applied", localSortKey: 2 },
    {
      translationText: "patientApplications.applied_to_waitlist",
      key: "1",
      value: "applied to waitlist",
      localSortKey: 3
    },
    { translationText: "patientApplications.approved", value: "approved", localSortKey: 4 },
    { translationText: "patientApplications.expired", value: "expired", localSortKey: 5 },
    { translationText: "patientApplications.exhausted", value: "exhausted", localSortKey: 6 },
    { translationText: "patientApplications.canceled", value: "canceled", localSortKey: 7 },
    { translationText: "patientApplications.denied", value: "rejected", localSortKey: 8 },
    { translationText: "patientApplications.ineligible", value: "ineligible", localSortKey: 9 },
    { translationText: "patientApplications.not_interested", value: "not-interested", localSortKey: 10 },
    { translationText: "patientApplications.not_returned", value: "not-returned", localSortKey: 11 },
    { translationText: "patientApplications.missing_information", value: "missing information", localSortKey: 12 },
    { translationText: "patientApplications.temporarily_approved", value: "temporarily approved", localSortKey: 13 }
  ],
  diagnosisType: [
    { key: "1", value: "cancer", translationText: "cancer" },
    { key: "2", value: "non-cancer", translationText: "non_cancer" }
  ],
  planMarketTypes: PLAN_MARKET_FILTER_OPTIONS,
  potentialSavingsTypes: POTENTIAL_SAVINGS_TYPES,
  potentialSavingsTypesWithSupport: [
    ...POTENTIAL_SAVINGS_TYPES.slice(0, 6),
    {
      key: programClassifications.SUPPORT_ADHERENCE.value,
      value: programClassifications.SUPPORT_ADHERENCE.value,
      translationText: "support_program"
    },
    ...POTENTIAL_SAVINGS_TYPES.slice(6)
  ],
  claimPotentialSavingsTypes: [
    {
      key: programClassifications.MANUFACTURER_COPAY.value,
      value: programClassifications.MANUFACTURER_COPAY.value,
      translationText: "manufacturer_copay"
    },
    {
      key: programClassifications.FOUNDATION_COPAY.value,
      value: programClassifications.FOUNDATION_COPAY.value,
      translationText: "foundation_copay"
    },
    {
      key: programClassifications.FOUNDATION_PREMIUM.value,
      value: programClassifications.FOUNDATION_PREMIUM.value,
      translationText: "foundation_premium"
    },
    {
      key: programClassifications.INTERNAL_PROGRAMS.value,
      value: programClassifications.INTERNAL_PROGRAMS.value,
      translationText: "internal"
    }
  ],
  patientAge: [
    { key: "10", value: "1", translationText: "0-18", id: "0_18" },
    { key: "20", value: "2", translationText: "18-65", id: "18_65" },
    { key: "30", value: "3", translationText: "65", id: "65" },
    { key: "40", value: "4", translationText: "65+", id: "65_plus" }
  ],
  applicationSignatureStatuses: APPLICATION_FORM_SIGNATURE_STATUS_FILTER_OPTIONS
};

export const administrationType = [
  { key: "1", value: "outpatient", translationText: "Outpatient" },
  { key: "2", value: "clinic", translationText: "Clinic" },
  { key: "3", value: "self", translationText: "Self" }
];

export const assistanceProgramStatus = [
  { key: "1", value: "open", translationText: "Open" },
  { key: "2", value: "waitlist", translationText: "Wait List" }
];

export const defaultRelevantPatientsFilters = {
  statuses: [],
  diagnosisNames: [],
  diagnosisCodeIDs: [],
  assignees: [],
  facilities: [],
  doctors: [],
  payers: [],
  isUnassigned: false
};

export const MainBucketsTrackEvents = Object.freeze({
  BUCKET_FILTER_CHANGED: "bucket_filter_changed",
  BUCKET_COLUMN_SELECTOR_SELECTED: "bucket_column_selector_selected"
});

export const FILTER_PATIENT_ASSIGNEE = "filter_patient_assignee";
export const DIAGNOSIS_FILTER_ISC_CODE = "diagnosis_filter_icd_code";
export const DIAGNOSIS_FILTER_NAME = "diagnosis_filter_name";
export const DIAGNOSIS_FILTER_DATE = "diagnosis_filter_date";
export const DRUG_FILTER_CREATED_DATE = "drug_filter_created_date";
export const FILTER_ENROLLMENT_ASSIGNEE = "filter_enrollment_assignee";
export const FILTER_CLAIM_ASSIGNEE = "filter_claim_assignee";
export const FILTER_CLAIM_LAST_SAVED_BY = "filter_claim_last_saved_by";
export const TABLE_FILTER_CONTAINER_ID = "table-filters-container";
